<template>
    <v-select
            v-bind="$props"
            v-on="$listeners"
            @change="focusSelf"
            ref="select"
    ></v-select>
</template>

<script>
    export default {
        name: "SSelect",
        props: {
            'value': {type:[String, Number, Boolean]},

            'label': String,
            'prepend-icon': String,
            'append-icon':String,
            'items': Array,
            'rules': Array,
            itemText: String,
            itemValue: String,
            disabled: Boolean,
            clearable:{type:Boolean, default:false},
            name: String,
            browserAutocomplete: {type:String, default:"on"},
        },
        methods: {
            focusSelf() {
                this.$refs.select.blur();
                this.$nextTick(()=>{
                    this.$refs.select.focus();
                });
            }
        }
    }
</script>

<style scoped>

</style>
